import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Don't initialize if already initialized
    if (this.element.dataset.perfumeSelectInitialized) {
      return
    }

    this.element.dataset.perfumeSelectInitialized = 'true'

    // Hide the original select
    this.element.style.display = 'none'

    // Store original options (skip the blank option)
    this.options = Array.from(this.element.options)
      .filter(opt => opt.value !== '')
      .map(opt => ({
        value: opt.value,
        text: opt.text
      }))

    // Create search input
    this.searchInput = document.createElement('input')
    this.searchInput.type = 'text'
    this.searchInput.className = 'form-control'
    this.searchInput.placeholder = 'Type to search perfumes...'
    this.searchInput.autocomplete = 'off'

    // Create dropdown list
    this.dropdown = document.createElement('div')
    this.dropdown.className = 'perfume-dropdown'
    this.dropdown.style.cssText = `
      position: absolute;
      z-index: 1000;
      background: white;
      border: 1px solid #ced4da;
      border-radius: 0.375rem;
      max-height: 300px;
      overflow-y: auto;
      width: 100%;
      display: none;
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    `

    // Create wrapper for positioning
    this.wrapper = document.createElement('div')
    this.wrapper.style.position = 'relative'
    this.wrapper.style.width = '100%'

    // Insert everything
    this.element.parentNode.insertBefore(this.wrapper, this.element)
    this.wrapper.appendChild(this.searchInput)
    this.wrapper.appendChild(this.dropdown)

    // Set initial value if select has a value
    const selectedOption = Array.from(this.element.options).find(opt => opt.selected && opt.value !== '')
    if (selectedOption) {
      this.searchInput.value = selectedOption.text
    }

    // Event listeners
    this.searchInput.addEventListener('input', (e) => this.handleInput(e))
    this.searchInput.addEventListener('focus', (e) => this.handleFocus(e))
    this.searchInput.addEventListener('blur', (e) => this.handleBlur(e))

    // Click outside to close
    document.addEventListener('click', (e) => {
      if (!this.wrapper.contains(e.target)) {
        this.hideDropdown()
      }
    })
  }

  handleInput(e) {
    const searchTerm = e.target.value.toLowerCase().trim()

    if (searchTerm === '') {
      this.hideDropdown()
      this.element.value = ''
      return
    }

    // Filter options
    const matches = this.options.filter(opt =>
      opt.text.toLowerCase().includes(searchTerm)
    )

    if (matches.length === 0) {
      this.dropdown.innerHTML = '<div style="padding: 0.5rem; color: #6c757d;">No perfumes found</div>'
      this.showDropdown()
    } else {
      this.dropdown.innerHTML = matches.map(opt => `
        <div class="perfume-option"
             data-value="${opt.value}"
             style="padding: 0.5rem; cursor: pointer; border-bottom: 1px solid #f0f0f0;"
             onmouseover="this.style.backgroundColor='#f8f9fa'"
             onmouseout="this.style.backgroundColor='white'">
          ${opt.text}
        </div>
      `).join('')

      // Add click handlers
      this.dropdown.querySelectorAll('.perfume-option').forEach(item => {
        item.addEventListener('mousedown', (e) => {
          e.preventDefault() // Prevent blur
          this.selectOption(item.dataset.value, item.textContent.trim())
        })
      })

      this.showDropdown()
    }
  }

  handleFocus(e) {
    if (this.searchInput.value.trim() !== '') {
      this.handleInput(e)
    }
  }

  handleBlur(e) {
    // Delay to allow click on dropdown
    setTimeout(() => {
      this.hideDropdown()
    }, 200)
  }

  selectOption(value, text) {
    this.element.value = value
    this.searchInput.value = text
    this.hideDropdown()

    // Trigger change event on the select
    this.element.dispatchEvent(new Event('change', { bubbles: true }))
  }

  showDropdown() {
    this.dropdown.style.display = 'block'
  }

  hideDropdown() {
    this.dropdown.style.display = 'none'
  }

  disconnect() {
    if (this.wrapper && this.wrapper.parentNode) {
      this.wrapper.parentNode.insertBefore(this.element, this.wrapper)
      this.wrapper.remove()
    }
    this.element.style.display = ''
  }
}

